// src/layouts/LayoutRoute.jsx
import { Outlet } from "react-router-dom";
import CommonLayout from "../../pages/Layouts/CommonLayout";
import useMenus from "../../components/Global/useMenus";

const LayoutRoute = () => {
  const { drawerMenu } = useMenus(); // central hook

  return (
    <CommonLayout drawerMenu={drawerMenu}>
      <Outlet />
    </CommonLayout>
  );
};

export default LayoutRoute;
